import { Injectable } from '@angular/core';
import { DynamicModalLoaderService } from './dynamic-modal-loader.service';
import { ModalTypes } from '../components/modals/contants/modal-types.enum';
import { Observable } from 'rxjs/Observable';
import { ConfirmModalComponent } from '../components/modals/confirm-modal/confirm-modal.component';
import { PlaceholderModalComponent } from '../components/modals/placeholder-modal/placeholder-modal.component';
import { BasicModalComponent } from '../components/modals/basic-modal/basic-modal.component';
import { DynamicModalLoaderComponent } from '../components/modals/dynamic-modal-loader/dynamic-modal-loader.component';
import { ReassignTestModalComponent } from '../components/modals/reassign-test-modal/reassign-test-modal.component';
import { AboutBoxComponent } from '@ispm/migration/components/about-box/about-box.component';


@Injectable()
export class ModalLoaderNgjsService {
  ComponentsTypes = {
    confirm: 'confirm',
    basic: 'basic',
    placeholder: 'placeholder',
    reassign: 'reassign',
    aboutbox: 'aboutbox'
  };
 
  constructor(private modalLoader: DynamicModalLoaderService) {
  }

  popupModal(componentName: string,
             payload?: any,
             modalTypeName: string = 'confirm',
             name: string = 'DYNAMIC_MODAL_LOADER'): Observable<any> {
    return this.modalLoader.popupModal(this.getLoadingComponent(componentName), payload, this.getModalType(modalTypeName), name);
  }

  getLoadingComponent(componentName: string): any {
    switch (componentName) {
      case this.ComponentsTypes.placeholder:
        return PlaceholderModalComponent;
      case this.ComponentsTypes.basic:
        return BasicModalComponent;
      case this.ComponentsTypes.confirm:
        return ConfirmModalComponent;
      case this.ComponentsTypes.reassign:
        return ReassignTestModalComponent;
      case this.ComponentsTypes.aboutbox:
          return AboutBoxComponent;  
      default:
        return DynamicModalLoaderComponent;
    }
  }

  getModalType(modalTypeName: string): ModalTypes {
    switch (modalTypeName) {
      case 'ALERT':
        return ModalTypes.ALERT;
      case 'ERROR':
        return ModalTypes.ERROR;
      case 'INFO':
        return ModalTypes.INFO;
      case 'SUCCESS':
        return ModalTypes.SUCCESS;
      default:
        return ModalTypes.NONE;
    }
  }

}
